const translations = {
    contactName: 'Contact Name',
    email: 'Email',
    loading: 'Loading...',
    name: 'Name',
    noMoreClients: 'No more clients',
    phone: 'Phone'
};

export default translations;
